import { render, staticRenderFns } from "./MapNavigationPlaces.vue?vue&type=template&id=7d9988dc&"
import script from "./MapNavigationPlaces.vue?vue&type=script&lang=js&"
export * from "./MapNavigationPlaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HorizontalEntityCard: require('/srv/rir-platform/tourism/src/tourism-front/components/common/HorizontalEntityCard/index.vue').default,Empty: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Empty/index.vue').default})
